import request from '../utils/https'

// 交換物品列表
export function getExchangeItemList (params) {
    return request({
        url: '/exchange/itemList',
        method: 'post',
        data:params
    })
}

// 新增交換物品
export function createExchangeItem (params) {
    return request({
        url: '/exchange/createItem',
        method: 'post',
        data:params
    })
}
// 修改交換物品
export function modifyItem (params) {
    return request({
        url: '/exchange/modifyItem',
        method: 'post',
        data:params
    })
}

// 刪除交換物品
export function deleteItem (params) {
    return request({
        url: '/exchange/deleteItem',
        method: 'post',
        data:params
    })
}

// 提交交換申請
export function applyExchangeItem (params) {
    return request({
        url: '/exchange/applyItem',
        method: 'post',
        data:params
    })
}

// 提交交換申請
export function checkApplyStatus (params) {
    return request({
        url: '/exchange/checkApplyStatus',
        method: 'post',
        data:params
    })
}

// 提交交換申請
export function getApplyList (params) {
    return request({
        url: '/exchange/getApplyList',
        method: 'post',
        data:params
    })
}


